import { pdpSizes } from '../../../domain/sizes';

type Props = {
  selectedSizes: string[];
  setSelectedSizes: React.Dispatch<string[]>;
};

const sizeItemClassNames = 'text-center py-2 rounded cursor-pointer';

const SizeGrid: React.FC<Props> = ({ selectedSizes, setSelectedSizes }) => {
  function onClick(value: string) {
    if (value === allSizeValue) {
      setSelectedSizes([value]);
    } else if (selectedSizes.includes(value)) {
      setSelectedSizes(selectedSizes.filter((v) => v !== value));

      if (selectedSizes.length < 2) setSelectedSizes([allSizeValue]);
    } else {
      setSelectedSizes(
        [...selectedSizes, value].filter((v) => v !== allSizeValue)
      );
    }
  }

  const selectedClassNames = 'bg-forest text-white';
  const unselectedClassNames = 'bg-concrete text-black';

  const allSizeValue = 'ALL';

  return (
    <>
      <input
        type="button"
        name="all"
        className={`${sizeItemClassNames} ${
          selectedSizes.includes(allSizeValue)
            ? selectedClassNames
            : unselectedClassNames
        }`}
        onClick={() => onClick(allSizeValue)}
        value="All"
      />
      {pdpSizes.map((size) => (
        <input
          type="button"
          name={`size_${size}`}
          key={size}
          className={`${sizeItemClassNames} ${
            selectedSizes.includes(size)
              ? selectedClassNames
              : unselectedClassNames
          } rounded`}
          onClick={() => onClick(size)}
          value={size}
        />
      ))}
    </>
  );
};

export default SizeGrid;
